export default "__VITE_ASSET__8hEhgNy5__"